/**
 * Standardized Panel Size Constants
 * Used across SecondaryPanel components for consistent sizing
 */

export const PANEL_SIZES = {
  // Standard secondary panel sizes
  SECONDARY_DEFAULT: 40,
  SECONDARY_MIN: 30,
  SECONDARY_MAX: 70,
  
  // Document info panel (slightly smaller)
  DOCUMENT_INFO_DEFAULT: 35,
  DOCUMENT_INFO_MIN: 25,
  
  // Voice memo panels
  VOICE_MEMO_DEFAULT: 45,
  VOICE_MEMO_MIN: 30,
} as const;

